import { BrowserRouter } from "react-router-dom";
import Router from "./routes/router";
import theme from "./theme/theme";
import { ThemeProvider } from "@emotion/react";
import { TripProvider } from "./context/trip/tripProvider";
import { CalculatorProvider } from "./context/calculator/tour/calculatorProvider";
import { SitesAndActivityProvider } from "./context/calculator/sitesAndActivity/sitesAndActivityProvider";
import { AuthProvider } from "./context/auth/authProvider";
import { Provider } from "react-redux";
import store from './store/store';
import { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import RsuiteThemeBridge from "./theme/rSuiteThemeBridge";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 250,
      easing: 'ease-in-sine'
    });
  }, []);

  return (
    <BrowserRouter>
      <Provider store={store}>
        <AuthProvider>
          <TripProvider>
            <CalculatorProvider>
              <SitesAndActivityProvider>
                <ThemeProvider theme={theme}>
                  <RsuiteThemeBridge />
                  <Router />
                </ThemeProvider>
              </SitesAndActivityProvider>
            </CalculatorProvider>
          </TripProvider>
        </AuthProvider>
      </Provider>
    </BrowserRouter>
  );
}

export default App;